import { Sparkle } from "lucide-react"
import BaseSidebarButton from "./BaseSidebarButton"
import { TAB_TYPES } from "@/reducers/tabsSlice"
import { SparkleIconActive } from "@/components/icons/SparkleIcon"
import { usePrivateAgentTarget } from "@/hooks/usePrivateAgentTarget"
import { useSidebar } from "./SidebarContext"

const SlickAISidebarButton = ({ className }: { className?: string }) => {
  const { onActiveChatChange } = useSidebar()
  const { openPrivateAgentChat, targetJid, unreadCount } =
    usePrivateAgentTarget(onActiveChatChange)

  if (!targetJid) return null

  return (
    <BaseSidebarButton
      tabName={TAB_TYPES.SLICK_AI}
      icon={Sparkle}
      activeIcon={SparkleIconActive}
      tooltipText="Slick AI"
      className={className}
      onClick={() => void openPrivateAgentChat("SlickAISidebarButton")}
    >
      {unreadCount > 0 && (
        <div className="absolute right-[-3px] top-[-3px] z-[99999] flex h-4 min-w-4 items-center justify-center rounded-lg bg-base-primary p-1 text-[10px] font-semibold text-white">
          {unreadCount}
        </div>
      )}
    </BaseSidebarButton>
  )
}

export default SlickAISidebarButton
